import { registerCorvidEvent } from '@wix/editor-elements-corvid-utils';
import type {
  CorvidTypes,
  ICorvidEvent,
  ICorvidEventHandler,
  IComponentEvent,
} from '@wix/editor-elements-types/corvid';
import type { WixSDKItems } from '../../ProGallery.types';

export type OnGetMoreItemsPayload = {
  from: number;
};

export type OnGetMoreItemsComponentPayload = IComponentEvent<
  'onGetMoreItems',
  OnGetMoreItemsPayload
>;

export type OnGetMoreItemsCorvidEvent = ICorvidEvent<
  'onGetMoreItems',
  OnGetMoreItemsPayload
>;

export type IOnGetMoreItemsSDK = {
  onGetMoreItems(handler: ICorvidEventHandler<OnGetMoreItemsCorvidEvent>): void;
  totalItemsCount?: number;
  addItems?: (items: WixSDKItems) => void;
};

export interface IOnGetMoreItemsSDKProps {
  onGetMoreItems({ from }: { from: number }): void;
  isExternalPagination?: boolean;
  addedWixSDKItems?: WixSDKItems;
  totalItemsCount?: number;
}

export const onGetMoreItemsSDKFactory: CorvidTypes.CorvidSDKFactory<
  IOnGetMoreItemsSDKProps,
  IOnGetMoreItemsSDK
> = api => {
  const { setProps, props, compRef } = api;
  return {
    set totalItemsCount(totalItemsCount: number | undefined) {
      setProps({ totalItemsCount });
    },
    get totalItemsCount(): number | undefined {
      return props.totalItemsCount;
    },
    addItems(items: WixSDKItems) {
      compRef.addItems(items);
    },
    onGetMoreItems(handler) {
      setProps({ isExternalPagination: true });
      registerCorvidEvent<
        OnGetMoreItemsComponentPayload,
        OnGetMoreItemsCorvidEvent
      >('onGetMoreItems', api, handler, ({ componentEvent }) => {
        return componentEvent;
      });
    },
  };
};
